import React, { createContext, useContext, useState } from "react";
import { walletConnectService } from "../utils/walletConnect";
import { toast } from "react-toastify";

const WalletContext = createContext();
export const useWallet = () => useContext(WalletContext);

/* 🔥 Mobile-safe error parser */
const parseWalletError = (err) => {
  const msg =
    err?.data?.message ||
    err?.error?.message ||
    err?.message ||
    "Wallet error";

  if (/rejected|denied|cancel/i.test(msg)) return "User rejected request";
  if (/insufficient/i.test(msg)) return "Insufficient BNB for gas";
  if (/network/i.test(msg)) return "Wrong network selected";
  if (/expired|session/i.test(msg)) return "Wallet session expired";
  return msg;
};

export const WalletProvider = ({ children }) => {
  const [walletAddress, setWalletAddress] = useState("");
  const [chainId, setChainId] = useState(null);
  const [provider, setProvider] = useState(null);
  const [isConnecting, setIsConnecting] = useState(false);

  const connectWallet = async () => {
    if (isConnecting) return;

    try {
      setIsConnecting(true);
      const res = await walletConnectService.connect();

      setWalletAddress(res.address);
      setChainId(res.chainId);
      setProvider(res.provider);

      toast.success("Wallet connected");
    } catch (e) {
      toast.error(parseWalletError(e));
    } finally {
      setIsConnecting(false);
    }
  };

  const disconnectWallet = async () => {
    await walletConnectService.disconnect();
    walletConnectService.removeAllListeners();

    setWalletAddress("");
    setChainId(null);
    setProvider(null);

    toast.info("Wallet disconnected");
  };

  const getWeb3 = () => {
    if (!provider) return null;
    const Web3 = require("web3");
    return new Web3(provider);
  };

  return (
    <WalletContext.Provider
      value={{
        walletAddress,
        chainId,
        provider,
        isConnecting,
        connectWallet,
        disconnectWallet,
        getWeb3,
        isConnected: !!walletAddress
      }}
    >
      {children}
    </WalletContext.Provider>
  );
};
